import React from "react";
import { combineReducers } from "redux";

import dashboardReducer from "./dashboard.reducer"
import deviceReducer from "./device.reducer"
import addressReducer from "./address.reducer"

export default combineReducers({
    dashboardReducer,
    deviceReducer,
    addressReducer
});